export const CART_API_ENDPOINT = '/cart';
export const RECOVERED_CART_API_ENDPOINT = '/recovered-cart';
export const TYPE_INFO = 'info';
export const TYPE_WARNING = 'warning';
export const TYPE_ERROR = 'error';
export const TYPE_SUCCESS = 'success';
export var CartStatusEnum;
(function (CartStatusEnum) {
    CartStatusEnum["CART_EXPIRE_IN_5_MINUTES"] = "5_MINUTES";
    CartStatusEnum["CART_EXPIRE_IN_SHORT_PERIOD"] = "SHORT_PERIOD";
    CartStatusEnum["CART_EXPIRED"] = "EXPIRED";
})(CartStatusEnum || (CartStatusEnum = {}));
// CART constants
export const CART_EXPIRES_IN_TEN_SECONDS = 11;
export const CART_EXPIRES_IN_ONE_MINUTE = 61;
export const CART_EXPIRES_IN_FIVE_MINUTES = 301;
//# sourceMappingURL=constants.js.map